export const uploadActionTypes = {
	UPLOAD_POST_URL_REQUEST: 'UPLOAD_POST_URL_REQUEST',
	UPLOAD_POST_URL_SUCCESS: 'UPLOAD_POST_URL_SUCCESS',
    UPLOAD_POST_URL_FAILURE: 'UPLOAD_POST_URL_FAILURE',
    
    UPLOAD_FILE_REQUEST: 'UPLOAD_FILE_REQUEST',
    UPLOAD_FILE_SUCCESS: 'UPLOAD_FILE_SUCCESS',
    UPLOAD_FILE_FAILURE: 'UPLOAD_FILE_FAILURE',
    UPLOAD_FILE_COMPLETE: 'UPLOAD_FILE_COMPLETE', //TODO: Do we need this?

    UPLOAD_FILE_PROGRESS: 'UPLOAD_FILE_PROGRESS',
    UPLOAD_FILE_STARTED: 'UPLOAD_FILE_STARTED',

    UPLOAD_ENQUEUE_ITEM: 'UPLOAD_ENQUEUE_ITEM',
    UPLOAD_DEQUEUE_ITEM: 'UPLOAD_DEQUEUE_ITEM',

    UPLOAD_CLEAR_ITEMS: 'UPLOAD_CLEAR_ITEMS',

    UPLOAD_CURRENT_COMPLETE: 'UPLOAD_CURRENT_COMPLETE',

    UPLOAD_SET_CURRENT_ALBUM: 'UPLOAD_SET_CURRENT_ALBUM',

    UPLOAD_PAUSE: 'UPLOAD_PAUSE',
    UPLOAD_CONTINUE: 'UPLOAD_CONTINUE',
    UPLOAD_STOP: 'UPLOAD_STOP',
    UPLOAD_RESTART: 'UPLOAD_RESTART',

    UPLOAD_THUMB_PROCESSED: 'UPLOAD_THUMB_PROCESSED',
    UPLOAD_CANCEL_DIALOG_TOGGLE: 'UPLOAD_CANCEL_DIALOG_TOGGLE',
    UPLOAD_UPLOADS_COMPLETE: 'UPLOAD_UPLOADS_COMPLETE',
    UPLOAD_UPLOADS_INPROGRESS: 'UPLOAD_UPLOADS_INPROGRESS'
};



// WEBPACK FOOTER //
// ./src/upload/actions/upload-action-types.js